import type { RunType } from "../types";

export const RUN_TYPE_LABELS: Record<RunType, string> = {
  chat: "Chat",
  dataset_builder: "Datasets",
  cli: "CLI",
  connector: "Connector",
};

const STEP_LABELS: Record<string, string> = {
  chat: "Chat agent",
  map: "Map",
  verify: "Verify",
  reduce: "Reduce",
  jev: "Jev",
  ask_image: "Ask image",
  read: "Read-once",
  search: "Search filter",
  other: "Other",
};

export const stepLabel = (step: string) => STEP_LABELS[step] ?? step;

const capitalize = (text: string) => text.charAt(0).toUpperCase() + text.slice(1);

/** "Datasets · Fast", or the run type alone when it has no mode. */
export const runTypeLabel = (runType: RunType, mode: string | null) => {
  const label = RUN_TYPE_LABELS[runType] ?? runType;
  return mode ? `${label} · ${capitalize(mode)}` : label;
};

export const formatCost = (usd: number) => {
  if (usd === 0) return "$0";
  if (usd < 0.01) return `$${usd.toFixed(4)}`;
  return `$${usd.toFixed(2)}`;
};

export const formatSeconds = (seconds: number | null) => {
  if (seconds === null) return "—";
  const whole = Math.round(seconds);
  if (whole < 60) return `${whole}s`;
  const minutes = Math.floor(whole / 60);
  if (minutes < 60) return `${minutes}m ${String(whole % 60).padStart(2, "0")}s`;
  return `${Math.floor(minutes / 60)}h ${String(minutes % 60).padStart(2, "0")}m`;
};

const compact = new Intl.NumberFormat("en", { notation: "compact", maximumFractionDigits: 1 });

export const formatCount = (count: number) => compact.format(count);

export const formatTime = (iso: string | null) =>
  iso ? new Date(iso).toLocaleString() : "—";
